<template>
  <div>
    <div class="back" v-if="isVisible" @click="hideModal"></div>
    <div class="serviceView" v-if="isVisible">
      <div class="modalView_pop">
        <div class="modalView_pop_l">
          <div class="modalView_pop_l_view">
            <div class="modalView_pop_l_view_t">
              <div class="modalView_pop_l_view_t_1">
                <div class="modalView_pop_l_view_t_3_text">{{ $t('Knowledge.KnowledgeTitle') }}</div>
              </div>
              <div class="modalView_pop_l_view_t_2">{{ $t('Knowledge.KnowledgeDesc') }}</div>
            </div>

            <!-- 知识库内容区域 -->
            <div class="knowledge-content">
              <!-- 知识库列表 -->
              <div class="knowledge-list" ref="knowledgeList">
                <div v-for="(item, index) in dataList" :key="index" class="knowledge-item" :class="{
                  'selected-item': item.text.length === 0 && item.name === baseName && !item.isEditing,
                  'expanded-item': item.isShowEient && item.text.length > 0 && !item.isEditing,
                  'editing-item': item.isEditing && item.text.length > 0,
                  'has-content': item.text.length > 0
                }" @click="handlerItemClick(index)">
                  <div class="item-header">
                    <span class="item-name"
                      :class="{ 'selected-text': item.text.length === 0 && item.name === baseName && !item.isEditing }">
                      {{ item.name }}
                    </span>

                    <!-- 根据状态显示不同的操作按钮 -->
                    <div class="item-actions">
                      <!-- 空内容时显示添加按钮 -->
                      <el-button v-if="item.text.length === 0 && !item.isEditing" type="text" icon="el-icon-plus"
                        class="action-btn" @click.stop="handlerBaseImage(index)" />

                      <!-- 有内容时显示编辑 -->
                      <el-button v-else-if="item.text.length > 0 && item.isShowEient && !item.isEditing" type="text"
                        icon="el-icon-edit" class="action-btn" @click.stop="handlerEditBaseImage(index, $event)" />
                      <!-- 有内容时并打开内容框展示删除按钮 -->
                      <el-button v-else-if="item.text.length > 0 && !item.isShowEient && !item.isEditing" type="text"
                        icon="el-icon-delete" class="action-btn delete-btn"
                        @click.stop="handlerTrashImage(index, $event)" />
                    </div>
                  </div>

                  <!-- 加载中状态 -->
                  <div v-if="item.isShowEient && item.sendLoading" class="loading-container">
                    <i class="el-icon-loading" />
                    <span>{{ $t('Knowledge.sending') }}</span>
                  </div>

                  <!-- 错误信息 -->
                  <div v-else-if="item.errorMessage" class="error-container" @click.stop="clearError(index, $event)">
                    <i class="el-icon-warning" />
                    <span>{{ item.errorMessage }}</span>
                  </div>

                  <!-- 内容区域 -->
                  <div v-else-if="item.isShowEient && item.text.length > 0" class="item-content">
                    <!-- 编辑模式 -->
                    <div v-if="item.isEditing" class="edit-mode" @click.stop>
                      <el-input v-model="item.editText" type="textarea" :rows="8"
                        :placeholder="$t('Knowledge.inputPlaceholder')" class="edit-textarea" ref="editTextarea" />
                      <div class="edit-actions">
                        <el-button size="small" @click.stop="cancelEdit(index, $event)">
                          {{ $t('Knowledge.cancel') }}
                        </el-button>
                        <el-button size="small" type="primary" @click.stop="saveEdit(index, $event)">
                          {{ $t('Knowledge.save') }}
                        </el-button>
                      </div>
                    </div>

                    <!-- 查看模式 -->
                    <div v-else class="view-mode" @click.stop="handlerCenter(index)">
                      {{ item.text }}
                    </div>
                  </div>
                </div>
              </div>

              <!-- 底部输入区域 - 仅当选中空项目时显示 -->
              <div class="knowledge-footer" v-if="baseName && selectedItemIsEmpty && !isEditingAny">
                <!-- 附件列表 -->
                <div v-if="requestData.files.length > 0" class="file-list">
                  <div v-for="(file, idx) in requestData.files" :key="file.upload_file_id" class="file-item">
                    <span class="file-name">{{ file.name }}</span>
                    <i class="el-icon-close" @click.stop="delFile(idx)" />
                  </div>
                </div>

                <!-- 输入框 -->
                <div class="input-wrapper" v-if="baseName && selectedItemIsEmpty && !isEditingAny">
                  <div class="chat-input-container">
                    <el-input v-model="inputText" type="textarea" :rows="3"
                      :placeholder="$t('Knowledge.invalidFormat', { formats: fileAccept })" :disabled="isSending"
                      class="chat-input" @keyup.ctrl.native.enter="send" />
                    <div class="input-actions-inline">
                      <el-button type="text" icon="el-icon-paperclip" :disabled="isSending" @click="triggerFileUpload"
                        class="upload-btn" />
                      <el-button type="primary" size="small" :loading="isSending" :disabled="!inputText.trim()"
                        @click="send" class="send-btn">
                        {{ $t('Knowledge.send') }}
                      </el-button>
                    </div>
                  </div>
                  <input ref="fileInput" type="file" :accept="fileAccept" multiple style="display: none"
                    @change="handleFileChange" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { getKnowledge, postKnowledge, uploadFile } from '@/api/index';

export default {
  data() {
    return {
      isVisible: false,
      inputText: '',
      baseName: '',
      isSending: false,
      accessType: 'tz',
      fileAccept: ".xls,.xlsx,.txt,.doc,.docx,.pdf,.zip,.rar,.7z,.tar",
      uploading: false,

      dataList: [
        { name: '个人背景资料', text: '', isShowEient: false, sendLoading: false, errorMessage: '', isEditing: false, editText: '' },
        { name: '机构背景资料', text: '', isShowEient: false, sendLoading: false, errorMessage: '', isEditing: false, editText: '' },
        { name: '项目资料', text: '', isShowEient: false, sendLoading: false, errorMessage: '', isEditing: false, editText: '' },
        { name: '使用目的说明', text: '', isShowEient: false, sendLoading: false, errorMessage: '', isEditing: false, editText: '' },
        { name: '战略规划或未来目标', text: '', isShowEient: false, sendLoading: false, errorMessage: '', isEditing: false, editText: '' }
      ],

      requestData: { files: [] },
      file_ids: []
    };
  },

  computed: {
    ...mapState(["userInfo"]),

    fieldMap() {
      return {
        '个人背景资料': 'personal_background',
        '机构背景资料': 'company_background',
        '项目资料': 'project_material',
        '使用目的说明': 'usage_purpose',
        '战略规划或未来目标': 'strategic_plan'
      };
    },

    selectedItemIsEmpty() {
      if (!this.baseName) return false;
      const currentItem = this.dataList.find(item => item.name === this.baseName);
      return currentItem && currentItem.text.length === 0;
    },

    isEditingAny() {
      return this.dataList.some(item => item.isEditing === true);
    }
  },

  methods: {
    showModal() {
      this.isVisible = true;
      this.initList();
    },

    hideModal() {
      this.isVisible = false;
      this.baseName = '';
      this.inputText = '';
      this.requestData.files = [];
      this.file_ids = [];
    },

    async initList() {
      try {
        const res = await getKnowledge(this.userInfo.user_id);
        let hasAnyData = false;
        const data = res.data?.data || res.data || res;

        this.dataList.forEach(item => {
          const fieldName = this.fieldMap[item.name];
          if (fieldName && data.hasOwnProperty(fieldName)) {
            const val = data[fieldName];
            if (val !== null && val !== undefined && String(val).trim() !== '') {
              item.text = String(val);
              hasAnyData = true;
            } else {
              item.text = '';
            }
          } else {
            item.text = '';
          }
        });

        if (!hasAnyData) {
          console.log('暂无知识库数据');
        }
      } catch (error) {
        console.error('获取知识库数据失败:', error);
        this.$message({
          message: this.$t('Knowledge.loadFail'),
          type: 'error'
        });
      }
    },

    triggerFileUpload() {
      this.$refs.fileInput.click();
    },

    async handleFileChange(event) {
      const files = Array.from(event.target.files);
      if (files.length === 0) return;
      event.target.value = '';

      const invalidFiles = files.filter(file => file.size / 1024 / 1024 > 10);
      if (invalidFiles.length > 0) {
        this.$message({
          message: this.$t('Knowledge.fileSizeLimit'),
          type: 'error'
        });
        return;
      }

      this.uploading = true;

      // ✅ 方案1：使用 loading 实例，手动关闭
      const loadingMsg = this.$message({
        message: this.$t('Knowledge.uploading'),
        type: 'info',
        duration: 0 // 不自动关闭
      });

      let successCount = 0;
      let failCount = 0;

      for (const file of files) {
        const result = await this.uploadSingleFile(file);
        if (result && result.success) {
          successCount++;
        } else {
          failCount++;
        }
      }

      // ✅ 关闭 loading 消息
      if (loadingMsg && loadingMsg.close) {
        loadingMsg.close();
      }

      if (successCount > 0) {
        this.$message({
          message: `${successCount} ${this.$t('Knowledge.uploadSuccess')}`,
          type: 'success'
        });
      }

      if (failCount > 0) {
        this.$message({
          message: `${failCount} ${this.$t('Knowledge.uploadFail')}`,
          type: 'error',
          duration: 5000
        });
      }

      this.uploading = false;
    },

    async uploadSingleFile(file) {
      try {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('user', this.userInfo?.user_id);
        formData.append('access_type', this.accessType);
        formData.append('type', this.fileAccept);

        const response = await uploadFile(formData);
        const uploadData = response.data || response;

        if (uploadData && uploadData.id) {
          const fileData = {
            name: uploadData.filename || file.name,
            upload_file_id: uploadData.id
          };

          this.requestData.files.push(fileData);
          this.file_ids.push(uploadData.id);
          this.inputText = this.$t('Knowledge.uploadAttachment');

          return { success: true, data: fileData };
        } else if (uploadData && uploadData.code === 200) {
          const data = uploadData.data;
          if (data && data.id) {
            const fileData = {
              name: data.filename || file.name,
              upload_file_id: data.id
            };

            this.requestData.files.push(fileData);
            this.file_ids.push(data.id);
            this.inputText = this.$t('Knowledge.uploadAttachment');

            return { success: true, data: fileData };
          }
        }

        const errorMsg = uploadData?.message || '上传失败';
        throw new Error(errorMsg);
      } catch (error) {
        console.error(`文件 ${file.name} 上传失败:`, error);
        return { success: false, error: error.message };
      }
    },

    handlerItemClick(index) {
      const currentItem = this.dataList[index];
      if (!currentItem) return;

      if (this.isEditingAny && !currentItem.isEditing) {
        this.$message({
          message: this.$t('Knowledge.saveOrCancel'),
          type: 'warning'
        });
        return;
      }

      if (currentItem.sendLoading) {
        this.$message({
          message: this.$t('Knowledge.sendingWait'),
          type: 'warning'
        });
        return;
      }

      const wasAlreadyExpanded = currentItem.isShowEient;

      this.dataList.forEach(item => {
        item.isShowEient = false;
        item.isEditing = false;
      });

      const hasContent = currentItem.text && typeof currentItem.text === 'string' && currentItem.text.trim().length > 0;

      if (hasContent) {
        if (!wasAlreadyExpanded) {
          currentItem.isShowEient = true;
        }
        if (this.baseName) {
          this.baseName = '';
        }
        return;
      }

      if (this.baseName === currentItem.name) {
        this.baseName = '';
      } else {
        this.baseName = currentItem.name;
        this.$nextTick(() => {
          const inputEl = document.querySelector('.serviceView .chat-input textarea');
          if (inputEl) inputEl.focus();
        });
      }
    },

    handlerBaseImage(index) {
      const currentItem = this.dataList[index];
      if (!currentItem) return;

      if (this.isEditingAny) return;
      if (currentItem.text.length > 0) return;

      currentItem.errorMessage = '';

      if (this.baseName === currentItem.name) {
        this.baseName = '';
      } else {
        this.baseName = currentItem.name;

        this.dataList.forEach((item, idx) => {
          if (idx !== index) {
            item.isShowEient = false;
            item.isEditing = false;
            item.errorMessage = '';
          }
        });

        currentItem.isShowEient = false;

        this.$nextTick(() => {
          const inputEl = document.querySelector('.serviceView .chat-input textarea');
          if (inputEl) inputEl.focus();
        });
      }
    },

    handlerTrashImage(index, event) {
      const item = this.dataList[index];
      if (!item) return;
      if (item.sendLoading || item.isEditing) return;

      this.$confirm(
        this.$t('Knowledge.deleteConfirm'),
        this.$t('Knowledge.tips'),
        {
          confirmButtonText: this.$t('Knowledge.delete'),
          cancelButtonText: this.$t('Knowledge.cancel'),
          type: 'warning',
          confirmButtonClass: 'el-button--danger'
        }
      ).then(async () => {
        item.sendLoading = true;

        try {
          const obj = {
            content: '',
            field_name: this.fieldMap[item.name],
            file_ids: [],
            use_dify: false
          };

          await this.handlerKnowledge(obj);

          item.text = '';
          item.isShowEient = false;
          item.errorMessage = '';
          item.isEditing = false;
          item.editText = '';

          if (this.baseName === item.name) {
            this.baseName = '';
          }

          this.$message({
            message: this.$t('Knowledge.deleteSuccess'),
            type: 'success'
          });
        } catch (error) {
          console.error('删除失败:', error);
          item.errorMessage = error.data?.message || this.$t('Knowledge.deleteFail');
          this.$message({
            message: this.$t('Knowledge.deleteFail'),
            type: 'error'
          });
        } finally {
          item.sendLoading = false;
        }
      }).catch(() => { });
    },

    handlerEditBaseImage(index, event) {
      const item = this.dataList[index];
      if (!item) return;

      item.isEditing = true;
      item.editText = item.text;

      this.$nextTick(() => {
        const textarea = document.querySelector(`.knowledge-item:nth-child(${index + 1}) .edit-textarea textarea`);
        if (textarea) {
          textarea.focus();
        }
      });
    },

    async saveEdit(index, event) {
      const item = this.dataList[index];
      if (!item || !item.isEditing) return;

      if (item.editText === item.text) {
        item.isEditing = false;
        return;
      }

      if (!item.editText?.trim()) {
        this.$message({
          message: this.$t('Knowledge.inputContent'),
          type: 'warning'
        });
        return;
      }

      item.sendLoading = true;

      try {
        const obj = {
          content: item.editText,
          field_name: this.fieldMap[item.name],
          file_ids: [],
          use_dify: false
        };

        const res = await this.handlerKnowledge(obj);
        if (res && res.data) {
          if (res.data.code !== 200) {
            item.errorMessage = res.data.message;
            this.inputText = '';
            this.requestData.files = [];
            this.file_ids = [];
          } else {
            item.text = String(res.data.data);

            this.inputText = '';
            this.requestData.files = [];
            this.file_ids = [];

            this.$message({
              message: this.$t('Knowledge.sendSuccess'),
              type: 'success'
            });
          }
        } else {
          item.text = item.editText;
        }

        item.isEditing = false;
        item.editText = '';

        this.$message({
          message: this.$t('Knowledge.saveSuccess'),
          type: 'success'
        });
      } catch (error) {
        console.error('保存失败:', error);
        item.errorMessage = error.data?.message || this.$t('Knowledge.saveFail');
        this.$message({
          message: this.$t('Knowledge.saveFail'),
          type: 'error'
        });
      } finally {
        item.sendLoading = false;
      }
    },

    cancelEdit(index, event) {
      const item = this.dataList[index];
      if (item) {
        item.isEditing = false;
        item.editText = '';
      }
    },

    clearError(index, event) {
      const item = this.dataList[index];
      if (item) {
        item.errorMessage = '';
      }
    },

    handlerCenter(index) { },

    async send() {
      if (this.isSending) return;

      if (!this.baseName) {
        this.$message({
          message: this.$t('Knowledge.selectProject'),
          type: 'warning'
        });
        return;
      }

      if (!this.inputText.trim()) {
        this.$message({
          message: this.$t('Knowledge.inputContent'),
          type: 'warning'
        });
        return;
      }

      const currentItem = this.dataList.find(item => item.name === this.baseName);
      if (!currentItem) return;
      if (currentItem.sendLoading) return;

      currentItem.isShowEient = true;
      currentItem.errorMessage = '';
      currentItem.sendLoading = true;
      this.isSending = true;

      try {
        const obj = {
          content: this.inputText,
          field_name: this.fieldMap[this.baseName],
          file_ids: this.file_ids,
          use_dify: true
        };

        const res = await this.handlerKnowledge(obj);

        if (res && res.data) {
          if (res.data.code !== 200) {
            currentItem.errorMessage = res.data.message;
            this.inputText = '';
            this.requestData.files = [];
            this.file_ids = [];
          } else {
            currentItem.text = String(res.data.data);
            this.inputText = '';
            this.requestData.files = [];
            this.file_ids = [];

            this.$message({
              message: this.$t('Knowledge.sendSuccess'),
              type: 'success'
            });
          }
        } else {
          currentItem.errorMessage = res.data.message;
          this.inputText = '';
          this.requestData.files = [];
          this.file_ids = [];
        }
      } catch (error) {
        console.error('发送失败:', error);

        let errorMessage = this.$t('Knowledge.sendFail');
        if (error.data?.message) {
          errorMessage = error.data.message;
        } else if (error.message) {
          errorMessage = error.message;
        }

        currentItem.errorMessage = errorMessage;

        this.$message({
          message: errorMessage,
          type: 'error',
          duration: 5000
        });
      } finally {
        currentItem.sendLoading = false;
        this.isSending = false;
      }
    },

    async handlerKnowledge(params) {
      try {
        const res = await postKnowledge(params);
        return res;
      } catch (error) {
        throw error;
      }
    },

    delFile(idx) {
      this.requestData.files.splice(idx, 1);
      this.file_ids.splice(idx, 1);
      if (this.requestData.files.length === 0) {
        this.inputText = '';
      }
    }
  }
};
</script>

<style scoped lang="scss">
.back {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  background: rgba(33, 33, 33, 0.5);
  height: 100vh;
  z-index: 999;
}

.serviceView {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: var(--global-background);
  width: 1200px;
  height: 90vh;
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  z-index: 1001;

  .modalView_pop {
    width: calc(100% - 20px);
    height: calc(100% - 20px);
    background-color: #ffffff;
    background-image: var(--global-inner-background);
    border-radius: 20px;
    display: flex;

    .modalView_pop_l {
      width: 1100px;
      height: 100%;
      position: relative;

      .modalView_pop_l_view {
        width: 100%;
        height: 100%;
        margin: 0 10px 0 35px;
        border-left: 2px dashed #E3E6E8;
        border-right: 2px dashed #E3E6E8;
        display: flex;
        flex-direction: column;

        .modalView_pop_l_view_t {
          width: 100%;
          border-bottom: 2px dashed #E3E6E8;
          height: 140px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          flex-shrink: 0;

          .modalView_pop_l_view_t_1 {
            width: auto;
            height: 46px;
            margin-left: 33px;

            .modalView_pop_l_view_t_3_text {
              font-size: 35px;
              color: rgba(33, 33, 33, 1);
              font-weight: 500;
            }
          }

          .modalView_pop_l_view_t_2 {
            font-size: 18px;
            color: rgba(0, 0, 0, 1);
            font-weight: 500;
            margin-left: 35px;
            letter-spacing: 3px;
          }
        }

        .knowledge-content {
          flex: 1;
          display: flex;
          flex-direction: column;
          overflow: hidden;
          padding: 20px 33px;

          .knowledge-list {
            flex: 1;
            overflow-y: auto;
            margin-bottom: 16px;

            &::-webkit-scrollbar {
              width: 6px;
            }

            &::-webkit-scrollbar-track {
              background: #f1f1f1;
              border-radius: 3px;
            }

            &::-webkit-scrollbar-thumb {
              background: #c1c1c1;
              border-radius: 3px;

              &:hover {
                background: #a8a8a8;
              }
            }
          }

          .knowledge-item {
            background: #fff;
            border-radius: 12px;
            margin-bottom: 16px;
            padding: 16px;
            transition: all 0.3s ease;
            border: 1px solid #e9ecef;
            position: relative;

            &:hover {
              box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
            }

            &.selected-item {
              border: 1px solid #18a1f6;
              background: rgba(24, 161, 246, 0.04);

              .item-name {
                color: #18a1f6;
                font-weight: 500;
              }
            }

            &.expanded-item {
              border: 1px solid #18a1f6;
              background: rgba(24, 161, 246, 0.04);
              box-shadow: 0 4px 12px rgba(24, 161, 246, 0.1);

              .item-name {
                color: #18a1f6;
                font-weight: 500;
              }
            }

            &.editing-item {
              border: 1px solid #18a1f6;
              background: rgba(24, 161, 246, 0.08);
              box-shadow: 0 4px 12px rgba(24, 161, 246, 0.15);

              .item-name {
                color: #18a1f6;
                font-weight: 600;
              }
            }

            &.has-content {
              cursor: pointer;
            }

            .item-header {
              display: flex;
              justify-content: space-between;
              align-items: center;

              .item-name {
                font-size: 16px;
                font-weight: 500;
                color: #052031;

                &.selected-text {
                  color: #18a1f6;
                }
              }

              .item-actions {
                display: flex;
                gap: 8px;

                .action-btn {
                  padding: 6px;
                  font-size: 18px;

                  &.delete-btn {
                    color: #f56c6c;

                    &:hover {
                      color: #f56c6c;
                      background: rgba(245, 108, 108, 0.1);
                    }
                  }
                }
              }
            }

            .loading-container {
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              padding: 40px 0;
              gap: 12px;
              color: #18a1f6;

              i {
                font-size: 24px;
                animation: rotate 1s linear infinite;
              }
            }

            .error-container {
              display: flex;
              align-items: center;
              justify-content: center;
              gap: 8px;
              padding: 40px 0;
              color: #f56c6c;
              background: #fef0f0;
              border-radius: 8px;
              cursor: pointer;

              i {
                font-size: 16px;
              }
            }

            .item-content {
              margin-top: 12px;

              .edit-textarea {
                :deep(.el-textarea__inner) {
                  font-size: 16px;
                  line-height: 1.6;
                  resize: vertical;
                  height: 330px;
                  overflow-y: auto;

                  &::-webkit-scrollbar {
                    display: none;
                  }

                  scrollbar-width: none;
                  -ms-overflow-style: none;
                }
              }

              .edit-actions {
                display: flex;
                justify-content: flex-end;
                gap: 12px;
                margin-top: 12px;
              }

              .view-mode {
                background: white;
                height: 330px;
                padding: 16px;
                border-radius: 8px;
                font-size: 16px;
                line-height: 1.6;
                color: #5a6672;
                white-space: pre-wrap;
                word-break: break-word;
                max-height: 330px;
                overflow-y: auto;

                &::-webkit-scrollbar {
                  display: none;
                }

                scrollbar-width: none;
                -ms-overflow-style: none;
              }
            }
          }

          .knowledge-footer {
            flex-shrink: 0;
            border-top: 1px solid #e9ecef;
            padding-top: 16px;
            background: transparent;
            transition: all 0.3s ease;

            &.has-files {
              background: rgba(24, 161, 246, 0.02);
              border-radius: 16px;
              margin-top: 8px;
            }

            .file-list {
              display: flex;
              flex-wrap: wrap;
              gap: 12px;
              margin-bottom: 16px;
              padding: 8px 0;
              animation: slideDown 0.3s ease;

              .file-item {
                display: inline-flex;
                align-items: center;
                gap: 8px;
                padding: 6px 12px 6px 16px;
                background: linear-gradient(135deg, #f5f7fa 0%, #fff 100%);
                border-radius: 24px;
                font-size: 16px;
                border: 1px solid #e4e7ed;
                transition: all 0.2s ease;
                box-shadow: 0 1px 2px rgba(0, 0, 0, 0.02);

                &:hover {
                  border-color: #18a1f6;
                  box-shadow: 0 2px 8px rgba(24, 161, 246, 0.1);
                  transform: translateY(-1px);
                }

                .file-name {
                  max-width: 200px;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  color: #052031;
                }

                i {
                  cursor: pointer;
                  color: #909399;
                  font-size: 16px;
                  transition: all 0.2s ease;
                  width: 20px;
                  height: 20px;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  border-radius: 50%;

                  &:hover {
                    color: #f56c6c;
                    background: rgba(245, 108, 108, 0.1);
                    transform: scale(1.1);
                  }
                }
              }
            }

            .input-wrapper {
              animation: slideUp 0.4s cubic-bezier(0.4, 0, 0.2, 1);

              .chat-input-container {
                position: relative;
                background: #fff;
                border-radius: 20px;
                box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08), 0 1px 2px rgba(0, 0, 0, 0.05);
                transition: all 0.3s ease;

                &:hover {
                  box-shadow: 0 8px 28px rgba(0, 0, 0, 0.12);
                }

                &:focus-within {
                  box-shadow: 0 8px 28px rgba(24, 161, 246, 0.15);
                  transform: translateY(-2px);
                  animation: pulse 0.5s ease;
                }

                .chat-input {
                  :deep(.el-textarea__inner) {
                    font-size: 16px;
                    line-height: 3.6;
                    resize: vertical;
                    padding: 16px 100px 16px 20px;
                    border-radius: 20px;
                    border: 1px solid #e4e7ed;
                    background: #fff;
                    transition: all 0.3s ease;
                    font-family: inherit;

                    &:hover {
                      border-color: #c0c4cc;
                    }

                    &:focus {
                      border-color: #18a1f6;
                      outline: none;
                    }

                    &::placeholder {
                      color: #c0c4cc;
                      font-size: 16px;
                    }
                  }
                }

                .input-actions-inline {
                  position: absolute;
                  bottom: 16px;
                  right: 16px;
                  display: flex;
                  gap: 12px;
                  align-items: center;
                  background: transparent;
                  z-index: 2;

                  .upload-btn {
                    padding: 8px;
                    font-size: 20px;
                    color: #909399;
                    transition: all 0.2s ease;
                    border-radius: 12px;
                    width: 36px;
                    height: 36px;
                    display: flex;
                    align-items: center;
                    justify-content: center;

                    &:hover {
                      color: #18a1f6;
                      background: rgba(24, 161, 246, 0.1);
                      transform: scale(1.05);
                    }

                    &:active {
                      transform: scale(0.95);
                    }
                  }

                  .send-btn {
                    padding: 8px 20px;
                    font-size: 16px;
                    font-weight: 500;
                    border-radius: 24px;
                    background: linear-gradient(135deg, #18a1f6 0%, #0d8ae0 100%);
                    border: none;
                    transition: all 0.2s ease;
                    box-shadow: 0 2px 6px rgba(24, 161, 246, 0.3);

                    &:hover {
                      background: linear-gradient(135deg, #0d8ae0 0%, #0a7ac9 100%);
                      transform: translateY(-1px);
                      box-shadow: 0 4px 12px rgba(24, 161, 246, 0.4);
                    }

                    &:active {
                      transform: translateY(0);
                    }

                    &.is-disabled {
                      background: linear-gradient(135deg, #c0c4cc 0%, #a8abb2 100%);
                      box-shadow: none;
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}

// ✅ 动画定义放在最外层，不要嵌套在任何选择器里面
@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(24, 161, 246, 0.4);
  }

  70% {
    box-shadow: 0 0 0 6px rgba(24, 161, 246, 0);
  }

  100% {
    box-shadow: 0 0 0 0 rgba(24, 161, 246, 0);
  }
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}
</style>